import { Context, createContext, useCallback, useState } from 'react'

import { Alert, AlertColor, Snackbar } from '@mui/material'

import { Box } from '@fairfashion/design-system'

interface FeedbackAlertProviderProps {
  children: React.ReactNode
}

interface FeedbackAlertContextType {
  feedbackAlert: (message: string, severity?: AlertColor) => void
}

export const FeedbackAlertContext: Context<FeedbackAlertContextType> =
  createContext({
    // eslint-disable-next-line
    feedbackAlert: (message: string, severity?: AlertColor) => {},
  })

export const FeedbackAlertProvider = ({
  children,
}: FeedbackAlertProviderProps) => {
  const [message, setMessage] = useState<string>('')
  const [severity, setSeverity] = useState<AlertColor>('info')
  const [open, setOpen] = useState(false)

  const feedbackAlert = useCallback(
    (message: string, severity?: AlertColor) => {
      setMessage(message)
      if (severity) {
        setSeverity(severity)
      } else {
        setSeverity('info')
      }

      setOpen(true)
    },
    [],
  )

  const closeAlert = () => {
    setOpen(false)
  }

  return (
    <FeedbackAlertContext.Provider value={{ feedbackAlert }}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={closeAlert}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          marginTop: 7,
        }}
      >
        <Alert
          onClose={closeAlert}
          severity={severity}
          sx={{
            width: '100%',
            border: '1px solid #E5E5E5',
          }}
        >
          <Box alignItems="center" height="100%">
            {message}
          </Box>
        </Alert>
      </Snackbar>
    </FeedbackAlertContext.Provider>
  )
}
